import axios from 'axios';
import { getToken, createApiUrl } from '../../util';
import { NewlyCreatedFacetHullCoords } from 'store/slices/ToolSlice/types';
import api from 'api/axiosInstance';
import { FacetEditShadingStatus } from 'api/editDsm';

async function translatePanels(translatePos: any, panelKey: string, uuid: string, solarDesign:boolean): Promise<FacetEditShadingStatus> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const body = {
		translatePositions:translatePos,
		uuid,
		panelKey
	};
		// TODO: handle the roof edit pitch properly
	if(!solarDesign){
		const apiUrl = '/designs/roof/update-roof-pitch';
		const body = {
			editedRoofs: translatePos,
			uuid,
			panelKey
		};
		const { data } = await api.post(createApiUrl(apiUrl), body, config);
		return data;
	}
	const apiUrl = '/designs/translate-panels-to-new-position';
	const { data } = await api.post(createApiUrl(apiUrl), body, config);
	return data;
}

export {
	translatePanels,
};